import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import produce from 'immer';

import * as constants from './constants';
import { NotificationsAction, NotificationsStoreState } from './typings';

const initialState: NotificationsStoreState = {
    headerNotifications: [],
    headerNotificationsLoadingStatus: LOADING_STATUSES.UNSENT,
    list: [],
    loadingStatus: LOADING_STATUSES.UNSENT,
};

const reducer = (state: NotificationsStoreState = initialState, action: NotificationsAction) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case constants.GET_NOTIFICATIONS_REQUEST: {
                draft.loadingStatus = LOADING_STATUSES.LOADING;
                break;
            }

            case constants.GET_NOTIFICATIONS_SUCCESS: {
                draft.loadingStatus = LOADING_STATUSES.SUCCESS;
                draft.list = action.notifications;
                break;
            }

            case constants.GET_NOTIFICATIONS_ERROR: {
                draft.loadingStatus = LOADING_STATUSES.ERROR;
                break;
            }

            case constants.GET_NOTIFICATIONS_HEADER_REQUEST: {
                draft.headerNotificationsLoadingStatus = LOADING_STATUSES.LOADING;
                break;
            }

            case constants.GET_NOTIFICATIONS_HEADER_SUCCESS: {
                draft.headerNotificationsLoadingStatus = LOADING_STATUSES.SUCCESS;
                draft.headerNotifications = action.notifications;
                break;
            }

            case constants.GET_NOTIFICATIONS_HEADER_ERROR: {
                draft.headerNotificationsLoadingStatus = LOADING_STATUSES.ERROR;
                break;
            }

            default:
                break;
        }
    });
};

export default reducer;
